import { SquareupFranklinApp, SquareupFranklinRequestContextProto } from '@cash-web/shared-util-protos'

import { CashRequestMiddleware } from './types'

let blockerDescriptorId: string | undefined
let profileToken: string

export const requestContextRequest: CashRequestMiddleware = request => {
  if (request.method !== 'GET') {
    const request_context = request?.data?.request_context ?? ({} as SquareupFranklinRequestContextProto.RequestContext)
    if (blockerDescriptorId != null) {
      request_context.blocker_descriptor_id = blockerDescriptorId
    }
    if (profileToken != null) {
      request_context.profile_token = profileToken
    }
    if (Object.keys(request_context).length > 0) {
      request.data ??= {}
      request.data.request_context = request_context
    }
  }
  return request
}

export const setBlockerDescriptorId = (id?: string) => {
  blockerDescriptorId = id
}
export const requestContextResponse = (data?: SquareupFranklinApp.GetProfileResponse) => {
  if (data?.profile_token != null && profileToken == null) {
    profileToken = data.profile_token
  }
  return data
}
